import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  redirectContainer: {
    color: 'inherit',
    textDecoration: 'none',
    fontSize: 16,
  },
}))
